<template>
  <div class="mdc-layout-container">
    <!-- Outlet for children routes -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Legal'
}
</script>

<style></style>
